import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import { LanguageProvider } from "@/i18n/LanguageContext";
import { Header } from "@/components/Header";
import { Hero } from "@/components/Hero";
import { Services } from "@/components/Services";
import { About } from "@/components/About";
import { QuoteForm } from "@/components/QuoteForm";
import { ContactHours } from "@/components/ContactHours";
import { Footer } from "@/components/Footer";

const Landing = () => (
  <div data-testid="landing-page" className="min-h-screen bg-[#FDFBF7]">
    <Header />
    <main>
      <Hero />
      <Services />
      <About />
      <QuoteForm />
      <ContactHours />
    </main>
    <Footer />
  </div>
);

function App() {
  return (
    <LanguageProvider>
      <div className="App">
        <Toaster position="top-right" richColors closeButton />
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<Landing />} />
          </Routes>
        </BrowserRouter>
      </div>
    </LanguageProvider>
  );
}

export default App;
